import React, { Component } from 'react'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import { Calendar } from 'hljd'
import { solarToLunar } from 'lunar-calendar'
import Style from './style.module.less'
import moment from 'moment'
import cls from 'classnames'
import { observer } from 'mobx-react'

@observer
export default class extends Component {
  // 获取农历信息
  getLunarStatus = value => {
    const solar = value.format('YYYY-MM-DD').split('-')
    const lunarInfo = solarToLunar(...solar)
    const { solarFestival, lunarFestival, term, lunarDayName } = lunarInfo
    const festivalName = solarFestival || lunarFestival || term
    if (festivalName && festivalName.length < 4) {
      return festivalName
    } else {
      return lunarDayName
    }
  }

  dateFullCellRender = value => {
    const { store } = this.props
    const { activeDate, monthSchedules } = store
    const day = value.get('D')
    const lunar = this.getLunarStatus(value)
    const valueFmt = value.format(__FMT1__)
    const currentData = monthSchedules.find(item => item.day == valueFmt) || {}
    const { hasReject, hasSchedule } = currentData

    // 是否是当月
    const isCurrentMonth = activeDate.get('M') != value.get('M')
    // 是否是选中
    const isCurrentDay = value.isSame(activeDate, 'day')
    // 是否是今日
    const isToday = value.isSame(moment(), 'day')

    return (
      <div
        className={cls({
          [Style.cell]: true,
          [Style.gray]: isCurrentMonth,
          [Style.active]: isCurrentDay,
          [Style.today]: isToday && !isCurrentDay,
          [Style.hasValue]: hasSchedule && !isCurrentDay,
          [Style.disable]: hasReject && !isCurrentDay
        })}
      >
        <div className={Style.day}>{day}</div>
        <div className={Style.lunar}>{lunar}</div>
      </div>
    )
  }

  leftMonth = () => {
    const { store } = this.props
    const { activeDate, onDateChange, months = [] } = store
    const activeMonth = activeDate.get('M')
    const activeYear = activeDate.get('Y')

    return (
      <div className={Style['calendar-left']}>
        <div className={Style.year}>
          <LeftOutlined
            className={Style.icon}
            onClick={() => {
              const date = moment(activeDate)
              date.subtract(1, 'years')
              onDateChange(date)
            }}
          />
          <div className={Style.num}>{activeYear}</div>
          <RightOutlined
            className={`${Style.icon} ${Style['icon-right']}`}
            onClick={() => {
              const date = moment(activeDate)
              date.add(1, 'years')
              onDateChange(date)
            }}
          />
        </div>
        <div>
          {months.map(({ orderNum, totalPrice, currentMonth }, index) => {
            const currentMonthDay = moment(activeDate)
            if (activeDate - index > 0) {
              currentMonthDay.subtract('months', activeMonth - index)
            } else {
              currentMonthDay.add('months', index - activeMonth)
            }

            let showPrice = totalPrice
            let unit = '元'
            if (totalPrice > 10000) {
              showPrice = (totalPrice / 10000).toFixed(2)
              unit = '万元'
            }

            return (
              <div
                key={index}
                className={cls({
                  [Style.month]: true,
                  [Style.active]: index == activeMonth
                })}
                onClick={() => {
                  onDateChange(currentMonthDay)
                }}
              >
                <div className={Style.num}>{index + 1}月</div>
                <div className={Style.text}>
                  {!!orderNum && `${orderNum}单`}
                  {!!(orderNum && totalPrice) && '/'}
                  {!!totalPrice && `${showPrice}${unit}`}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  render() {
    const { store } = this.props
    const { activeDate, onDateChange } = store
    const activeYear = activeDate.get('Y')
    const activeMonth = activeDate.get('M')

    return (
      <div className={Style.calendar}>
        {this.leftMonth()}
        <div className={Style['calendar-right']}>
          <div className={Style.title}>
            <img src="//qnm.hunliji.com/o_1ctf4060bvh8cleuk83d4ndh9.png" />
            {activeYear}年{activeMonth + 1}月全部档期
          </div>
          <Calendar
            headerRender={() => <></>}
            value={activeDate}
            onChange={onDateChange}
            dateFullCellRender={this.dateFullCellRender}
          />
        </div>
      </div>
    )
  }
}
